/* eslint-disable react/display-name */
import React, { forwardRef } from 'react'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import {
    DateFieldExtendedState,
    DateFieldValue,
} from '../shared/date'
import { DisplayErrors } from '../BaseDisplayItem'

export interface DateFieldEditProps {
    state: DateFieldExtendedState
    value: DateFieldValue
    errors?: DisplayErrors
    onChangeDate: (
        moment: moment.Moment | null,
        name?: string,
        searchType?: string
    ) => void
    isInvalid: () => boolean
    getErrorText: () => string
    getCurrentLocale: () => string
}

export const DateFieldEdit = forwardRef<
    HTMLDivElement,
    DateFieldEditProps
>(({ state, value, errors, onChangeDate, isInvalid }, ref) => {
    const parsed =
        value !== null && value !== undefined && typeof value === 'string'
            ? moment(value)
            : null

    const date = parsed?.isValid() ? parsed : null

    return (
        <div ref={ref}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                    value={date}
                    onChange={(momentValue) => {
                        onChangeDate?.(momentValue)
                    }}
                    format="DD-MM-YYYY"
                    views={['year', 'month', 'day']}
                    slotProps={{
                        textField: {
                            error: isInvalid(),
                            helperText: isInvalid() ? errors : null,
                            fullWidth: true,
                            size: 'small',
                        },
                        field: {
                            clearable: true,
                        },
                    }}
                    disableFuture={
                        state.restriction === 'before_and_eq_current_date'
                    }
                    disablePast={
                        state.restriction === 'after_and_eq_current_date'
                    }
                />
            </LocalizationProvider>
        </div>
    )
})
